<div class="dialog container-fluid no-padding col-md-12 display-flex">
    <div class="grey  col-md-6">
        <div class="row">
            <img class="pr-2 pointer" src="assets/svg/right-arrow.svg" alt="" (click)="previousPart()">
            <h6 class="pl-2 pr-2 mt-2">Part {{currentIndex+1}} of {{vendorOrderItems.length}}</h6>
            <img class="pl-2 pointer" src="assets/svg/left-arrow.svg" alt="" (click)="nextPart()">
        </div>
        <div class="thumbnail">
            <img [src]="partDetails?.thumbnail ? partDetails?.thumbnail : 'assets/svg/truventor_loader.svg'"
                alt="Part details image">
        </div>
        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">PART ID:</p>&nbsp;&nbsp;
                <h6 class="mb-0 medium">{{partDetails?.model_attributes?.model_code}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">PART NAME:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.model_attributes?.file_name}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">L x B x H:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.cleaned_model_attributes?.length}}mm&nbsp;x&nbsp;{{partDetails?.cleaned_model_attributes?.width}}mm&nbsp;x&nbsp;{{partDetails?.cleaned_model_attributes?.height}}mm
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">VOLUME:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.cleaned_model_attributes?.volume}}mm<sup>3</sup></h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">AREA:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.cleaned_model_attributes?.surface_area}}mm<sup>2</sup></h6>
            </div>
        </div>
        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">TECHNOLOGY:</p>&nbsp;&nbsp;
                <h6 class=" medium mb-0">{{partDetails?.technology_name}}</h6>
            </div>
            <div *ngIf="partDetails?.sub_technology_details?.name" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SUB TECHNOLOGY:</p>&nbsp;&nbsp;
                <h6 class=" medium mb-0">{{partDetails?.sub_technology_details ?
                    partDetails?.sub_technology_details?.name : '--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">MATERIAL:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.material_name}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACEE FINISH:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_surface_finishing?.name ? partDetails?.material_surface_finishing?.name :
                    '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE COLOR:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_surface_finishing?.color ? partDetails?.material_surface_finishing?.color :
                    '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE TREATMENT:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.material_heat_treatment?.name ? partDetails?.material_heat_treatment?.name : '--'}}
                </h6>
            </div>
        </div>
        <!-- !:##################################### Other options ############################################## -->
        <div class="mt-3 sub">
            <!-- :Not shown in new design -->
            <!-- <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE HARDNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.shore_hardness? partDetails?.shore_hardness?.name:'--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">SURFACE ROUGHNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.surface_roughness? partDetails?.surface_roughness?.name:'--'}}</h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">DEBURRING:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.deburring ? partDetails?.deburring : '--'}} 
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">RELIEF CUTS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.reliefcuts ? partDetails?.reliefcuts : '--'}} 
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">ROLLING / GRINDING DIRECTION:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.rollinggrinding ? partDetails?.rollinggrinding : '--'}} 
                </h6>
            </div> -->
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">THICKNESS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">

                    {{partDetails?.thickness?.thickness ? partDetails?.thickness?.thickness : '--'}}

                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">TOLERANCE:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.tolerance?.name ? partDetails?.tolerance?.name : '--'}}
                </h6>
            </div>
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">THREADED HOLES:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.taps?.name ? partDetails?.taps?.name : '--'}}
                </h6>
            </div>

            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">ADDITIONAL INSTRUCTIONS:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">{{partDetails?.instructions}}</h6>
            </div>
        </div>

        <div class="mt-3 sub">
            <div class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">INSPECTION TYPE:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    {{partDetails?.inspection ? partDetails?.inspection?.name : '--'}}
                </h6>
            </div>

            <div *ngIf="partDetails?.quality_control_params?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">QUALITY CONTROL PARAMS:</p>
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let param of partDetails?.quality_control_params">
                        <li class="ps-2">{{ param?.quality_checklist }}</li>
                    </ng-container>
                </h6>
            </div>

            <div *ngIf="partDetails?.reports?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">REPORTS:</p>
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let report of partDetails?.reports; let j=index">
                        <li class="ps-2">{{ report?.name }}</li>
                    </ng-container>
                </h6>
            </div>
            <div *ngIf="partDetails?.certificates?.length > 0" class="container-fluid no-padding ml-0 row mb">
                <p class="mb-0">CERTIFICATES:</p>&nbsp;&nbsp;
                <h6 class="medium mb-0">
                    <ng-container *ngFor="let certificate of partDetails?.certificates; let i=index">
                        <li class="ps-2">{{ certificate?.name }}</li>
                    </ng-container>
                </h6>
            </div>
        </div>

        <div class="container-fluid no-padding ml-0 row mt-2">
            <p class="mb-0">3D Files:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadModelFile()">{{partDetails?.model_attributes?.file_name}}</a>
        </div>
        <div class="container-fluid no-padding ml-0 row mt-1">
            <p class="mb-0">2D Files:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadDrawing()">Download All</a>
        </div>
        <div class="container-fluid no-padding ml-0 row mt-1"
            *ngIf="partDetails?.inspection?.name?.toLowerCase() === 'custom'">
            <p class="mb-0">Custom Inspection Files:</p>&nbsp;&nbsp;
            <a class="pointer" (click)="downloadCustomInspectionFile()">Download All</a>
        </div>
        <!-- <div class="container-fluid no-padding ml-0 row mt-2">
            <h6 class="light">INSTRUCTIONS:</h6>&nbsp;&nbsp;
            <p class="col-md-10 pl-0 pr-0">{{partDetails?.instructions? partDetails?.instructions:'--'}} </p>
        </div> -->

    </div>
    <div class="white col-md-6">
        <div class="loaderDiv" *ngIf="!partDetails">
            <img src="assets/svg/truventor_loader.svg">
        </div>

        <!-- <div *ngIf="partDetails" class="content">
            <h6 *ngIf="awardedRfq">Bidding Values:</h6>
            <h6 *ngIf="pendingPo">Cost Breakdown :</h6>
            <div class="row">
                <p class="regular grey-text col-md-8">Item Rate (INR/pc):</p>
                <h6 class="medium col-md-4">{{partDetails?.item_rate | currency:currency}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">Quantity:</p>
                <h6 class="medium col-md-4">{{partDetails?.quantity}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">Sub Total</p>
                <h6 class="medium col-md-4">{{partDetails?.sub_total | currency:currency}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">HSN Code:</p>
                <h6 class="medium col-md-4">{{partDetails?.hsn_code}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">Taxation %:</p>
                <h6 class="medium col-md-4">{{partDetails?.taxation}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">Part Total:</p>
                <h6 class="medium col-md-4">{{partDetails?.total_cost | currency:currency}}</h6>
            </div>
            <div class="mt-3 row">
                <p class="regular grey-text col-md-8">Time&nbsp;&nbsp;(Days):</p>
                <h6 class="medium col-md-4">{{partDetails?.time}}</h6>
            </div>
            <h6 class="medium">*Comment</h6>
            <p class="col-md-10 pl-0 pr-0">{{partDetails?.vendor_comments}} </p>
            <div class="footer">
                <button class="btn-white display-flex " (click)="close()">BACK</button>
            </div>

        </div> -->

        <div *ngIf="partDetails" class="content">
            <mat-tab-group animationDuration="0ms" disableRipple="true" class="inspection-tab-label" *ngIf="type == 'BID'">
                <mat-tab *ngFor="let bid_item_batch of partDetails?.dispatch_batch; let i=index">
                    <ng-template mat-tab-label>
                        Batch {{i+1}}
                    </ng-template>
                    <div>
                        <div class="content custom-form px-2 pt-2">
                            <h6>Enter Bidding Values:</h6>
                            <div class="mt-4 row">
                                <p class="medium col-md-8 mb-0">Item Rate (INR/pc):</p>
                                <p class="medium col-md-8 mb-0">{{bid_item_batch?.costing?.total_unit_cost}}</p>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Quantity:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.agreed_quantity}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Sub Total</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.total_unit_cost * bid_item_batch?.costing?.agreed_quantity}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">HSN Code:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.hsn_code}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Taxation %:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.tax_cost}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Batch Total:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.tax_cost}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Expected Delivery Date:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.dispatch_date ?
                                    (bid_item_batch?.dispatch_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Time(Lead Days):</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.lead_days}}
                                </h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">*Actual Delivery Date:</p>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.actual_date ?
                                    (bid_item_batch?.costing?.actual_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="custom-form comment">
                                <h6 class="medium mt-2  bg-white">*Comment</h6>
                                <h6 class="medium col-md-4">{{bid_item_batch?.costing?.comment}}
                                </h6>
                            </div>
                            <br>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>

            <mat-tab-group animationDuration="0ms" disableRipple="true" class="inspection-tab-label" *ngIf="type == 'ORDER'">
                <mat-tab *ngFor="let order_item_batch of partDetails?.vendor_order_item?.dispatch_batch; let i=index">
                    <ng-template mat-tab-label>
                       {{order_item_batch?.name}}
                    </ng-template>
                    <div>
                        <div class="content custom-form px-2 pt-2">
                            <!-- <h6>Enter Bidding Values:</h6> -->
                            <div class="mt-4 row">
                                <p class="medium col-md-8 mb-0">Item Rate:</p>
                                <p class="medium col-md-4 mb-0">{{order_item_batch?.costing?.total_unit_cost | currency:currency}}</p>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Quantity:</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.ordered_quantity}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Sub Total</p>
                                <h6 class="medium col-md-4">{{(order_item_batch?.costing?.total_unit_cost * order_item_batch?.ordered_quantity)  | currency:currency}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">HSN Code:</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.costing?.hsn_code}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Taxation %:</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.costing?.tax_cost}}%</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Tax Amount</p>
                                <h6 class="medium col-md-4">{{(order_item_batch?.costing?.tax_cost*.01*(order_item_batch?.costing?.total_unit_cost * order_item_batch?.ordered_quantity))  | currency:currency}}</h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Expected Delivery Date:</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.dispatch_date ?
                                    (order_item_batch?.dispatch_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Time(Lead Days):</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.costing?.lead_days}}
                                </h6>
                            </div>
                            <div class="mt-3 row">
                                <p class="medium col-md-8 mb-0">Actual Delivery Date:</p>
                                <h6 class="medium col-md-4">{{order_item_batch?.costing?.actual_date ?
                                    (order_item_batch?.costing?.actual_date | date: 'MMM d') : ('--')}}
                                </h6>
                            </div>
                            <div class="custom-form comment mt-3 row">
                                <h6 class="medium mt-2 col-md-8 bg-white">Comment</h6>
                                <h6 class="medium col-md-4">{{order_item_batch?.costing?.comment}}
                                </h6>
                            </div>
                            <br>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        
            <div class="footer">
                <button class="btn-white display-flex " (click)="close()">BACK</button>
            </div>
        </div>
    </div>
</div>